//utils
import { buildComputedForm } from "@u/methods";
import { ValidObj } from "@u/model";
import { rex_value, rex_password } from "@u/regex";
function formObj(_this) {
  return {
    oldPassword: {
      ...new ValidObj(""),
      key: "oldPassword",
      label: "原始密碼",
      placeholder: (label) => _this.$tp("please.enter", { label }),
      controlType: "password",
      valid: [
        { regex: rex_value, warn: (label) => _this.$tp("please.enter", { label }) }
      ]
    },
    password: {
      ...new ValidObj(""),
      key: "password",
      label: "新設密碼",
      placeholder: (label) => _this.$tp("please.enter", { label }),
      controlType: "password",
      valid: [
        { regex: rex_value, warn: (label) => _this.$tp("please.enter", { label }) },
        { regex: rex_password, warn: (label) => _this.$tp("warn.pwdRule") }
      ]
    },
    confirmPassword: {
      ...new ValidObj(""),
      key: "confirmPassword",
      label: "密碼確認",
      placeholder: () => "請再次輸入密碼",
      controlType: "password",
      valid: [
        {
          regex: (value) => _this.form.password.value === value,
          warn: () => _this.$tp("warn.pwdNotSame")
        }
      ]
    }
  }
}
export default {
  data() {
    return {
      form: formObj(this)
    }
  },
  computed: {
    ...buildComputedForm(formObj())
  }
}